import { Link } from 'react-router-dom'
import '../assets/css/ArticleCard.css'
import '../assets/css/Central.css'
import { formatDate, getImageUrl } from '../services/CommonService'
import { memo, useMemo } from 'react'

const ArticleCard = memo(function ArticleCard({articleId, categoryName, title, image, date, url, viewRelatedArticles}) {
    const memoisedFormatDate = useMemo(() => formatDate(date), [formatDate])

    return (
        <div className={`flex-container flex-column flex-wrap card zoom-card-animation`}>
            <div className='article-card-image-div'>
                <Link to={"/" + url} state={{ 
                    articleId: articleId,
                    title: title,
                    image: image,
                    date: memoisedFormatDate,
                    categoryName: categoryName,
                }}>
                    <img src={getImageUrl(image.imageName)} className='article-card-img' alt={image.altText} />
                </Link>
            </div>
            <div className='flex-container flex-column main-color-background text-white padding-2p-bottom-1p flex-wrap article-card-details'>
                {!viewRelatedArticles && (
                    <p className={categoryName === 'Promo' ? 'category-name category-name--promo' : 'category-name'}>
                        {categoryName}
                    </p>
                )}
                <Link to={"/" + url} state={{ 
                    articleId: articleId,
                    title: title,
                    image: image,
                    date: memoisedFormatDate,
                    categoryName: categoryName,
                }}>
                    <p className='font-weight-500'>
                        {title}
                    </p>
                </Link>
                {!viewRelatedArticles && <p className='flex-end-item small-text'>
                    {memoisedFormatDate}
                </p>}
            </div>
        </div>        
    )
})

ArticleCard.defaultProps = {
    viewRelatedArticles: false
}

export default ArticleCard